import React from "react";

import SupportLevelIcon from "./supportLevelIcon";

type MidProps = {
	merchant: any;
	label?: string;
	canHaveEmptySpace?: boolean;
};

const Mid = ({ merchant, label, canHaveEmptySpace = false }: MidProps) => {
	return (
		<div className="d-flex">
			<SupportLevelIcon
				className="mr-2"
				name={
					merchant?.priority_type ||
					merchant?.priorityType ||
					merchant?.merchant?.priorityType ||
					merchant?.merchantPriorityType ||
					""
				}
				canHaveEmptySpace={canHaveEmptySpace}
			/>
			{label || (merchant && merchant?.mid) || ""}
		</div>
	);
};

export default Mid;
